<template>
  <!--   <div class="color-code">
    <div class="categoria">
      <div class="color-rect" style="background-color: #3a5ca6"></div>
      Guardia Nacional
    </div>
    <div class="categoria">
      <div class="color-rect" style="background-color: #796952"></div>
      SEDENA
    </div>
  </div> -->
  <div class="color-code">
    <div class="categoria">
      <div class="color-rect" style="background-color: #796952"></div>
      SEDENA
    </div>
    <div class="categoria">
      <div class="color-rect" style="background-color: #3a5ca6"></div>
      Guardia Nacional
    </div>
  </div>

  <div class="tooltip-militarizacion" id="tooltip-militarizacion">
    SEDENA: <span class="highlight">{{ sedena_tooltip }}</span> <br /><br />
    G.N.: <span class="highlight">{{ gn_tooltip }} </span> <br /><br />
    Total: <span class="highlight">{{ total_tooltip }}</span>
  </div>

  <div class="contenedor-areas" id="contenedor-areas">
    <svg
      id="svg-areas"
      class="svg-areas"
      :width="ancho + margenes.derecha + margenes.izquierda"
      :height="alto_svg"
    >
      <g
        class="eje-x"
        :transform="`translate(${margenes.izquierda},${
          margenes.arriba + alto
        })`"
      ></g>
      <g
        class="eje-y"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-areas"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
    </svg>
  </div>
</template>

<script setup>
import * as d3 from "d3";
import { onMounted, onUnmounted, ref } from "vue";

const datos = ref([
  { anio: 2019, guardia_nacional: 2212, sedena: 3464 },
  { anio: 2020, guardia_nacional: 0, sedena: 2269 },
  { anio: 2021, guardia_nacional: 1235, sedena: 6894 },
  { anio: 2022, guardia_nacional: 6893, sedena: 6894 },
  { anio: 2023, guardia_nacional: 2655, sedena: 6544 },
  { anio: 2024, guardia_nacional: 2322, sedena: 7234 },
]);
const categorias = ref(["guardia_nacional", "sedena"]);
const stacked_data = ref();
const color_dict = ref({
  sedena: "#796952",
  guardia_nacional: "#3A5CA6",
});

const contenedor_svg = ref();
const svg = ref();
const ancho = ref(0);
const alto_svg = ref(400);
const alto = ref(0);
const margenes = ref({
  derecha: 20,
  izquierda: 65,
  abajo: 35,
  arriba: 20,
});

const grupo_areas = ref();
const escalaX = ref();
const escalaY = ref();
const eje_X = ref();
const eje_Y = ref();
const texto_x = ref();
const texto_y = ref();

const tooltip_militarizacion = ref();
const gn_tooltip = ref();
const sedena_tooltip = ref();
const total_tooltip = ref();

onMounted(() => {
  contenedor_svg.value = document.getElementById(`contenedor-areas`);
  svg.value = d3.select(`svg#svg-areas`);
  eje_X.value = svg.value.select("g.eje-x");
  eje_Y.value = svg.value.select("g.eje-y");
  grupo_areas.value = svg.value.select("g.grupo-areas");
  texto_x.value = svg.value.append("text").attr("text-anchor", "middle");
  texto_y.value = svg.value.append("text").attr("text-anchor", "middle");
  tooltip_militarizacion.value = d3.select("div#tooltip-militarizacion");
  tooltip_militarizacion.value.style("visibility", "hidden");
  //console.log(datos.value);

  stacked_data.value = d3.stack().keys(categorias.value)(datos.value);

  //console.log(stacked_data.value);
  dimensionandingLineas();
  graficaLineas();
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});

function reescalanding() {
  dimensionandingLineas();
  graficaLineas();
}
function dimensionandingLineas() {
  ancho.value =
    contenedor_svg.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;
  alto.value = alto_svg.value - margenes.value.arriba - margenes.value.abajo;

  escalaX.value = d3
    .scaleBand()
    .domain([2019, 2020, 2021, 2022, 2023, 2024])
    .range([0, ancho.value])
    .padding(0.2);

  escalaY.value = d3.scaleLinear().domain([0, 14000]).range([alto.value, 0]);

  eje_X.value.call(d3.axisBottom(escalaX.value));
  eje_Y.value.call(d3.axisLeft(escalaY.value));

  texto_x.value
    .attr(
      "x",
      (ancho.value + margenes.value.izquierda + margenes.value.derecha) / 2
    )
    .attr("y", alto.value + margenes.value.arriba + margenes.value.abajo - 2)
    .attr("font-size", "14")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .attr("font-weight", "bold")
    .text("Año");

  texto_y.value
    .attr("transform", "rotate(-90)")
    .attr("y", 15)
    .attr("x", -(alto.value + margenes.value.arriba + margenes.value.abajo) / 2)
    .attr("font-size", "14")
    .attr("font-weight", "bold")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .text("Elementos desplegados");
}

function graficaLineas() {
  grupo_areas.value
    .selectAll("g")
    .data(stacked_data.value)
    .join("g")
    .style("fill", (d) => color_dict.value[d.key])
    .selectAll("rect")
    .data((d) => d)
    .join("rect")
    .attr("x", (d) => escalaX.value(d.data.anio))
    .attr("y", (d) => escalaY.value(d[1]))
    .attr("height", (d) => escalaY.value(d[0]) - escalaY.value(d[1]))
    .attr("width", escalaX.value.bandwidth())
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip);
}

function abrirTooltip() {
  let seleccion = d3.select(this).datum().data;
  gn_tooltip.value = d3.format(",.0f")(seleccion.guardia_nacional);
  sedena_tooltip.value = d3.format(",.0f")(seleccion.sedena);
  total_tooltip.value = d3.format(",.0f")(
    seleccion.guardia_nacional + seleccion.sedena
  );

  tooltip_militarizacion.value.style("visibility", "visible");
}
function cerrarTooltip() {
  tooltip_militarizacion.value.style("visibility", "hidden");
}
function ajustarPosicionTooltip() {
  let position = d3.pointer(event, document.body);
  let x = position[0] - 100;
  let y = position[1] + 20;

  if (x < 0) {
    x = position[0] + 50;
  }

  tooltip_militarizacion.value.style("left", x + "px").style("top", y + "px");
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tooltip-militarizacion {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.93;
  height: auto;
  width: 100px;
  font-size: 14px;
  padding: 3px;
  text-align: left;
}
.color-code {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0px;
}
.categoria {
  display: flex;
  /*width: 20%; */
  padding: 0px 15px;
  margin: 0px;
  margin-top: 0px;
}
.color-rect {
  display: inline;
  padding: 3px;
  height: 12px;
  width: 12px;
  margin: 2px;
}

@media (max-width: 850px) {
  .color-code {
    justify-content: center;
  }
}
</style>
